import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

function LocalLogo({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 40 28"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                fill="#FFF"
                d="M0 15.36L2.851 15.36 2.851 0 0 0zM37.069 15.36L39.921 15.36 39.921 0 37.069 0z"
                transform="translate(-72 -18) translate(72 18) translate(0 4)"
              />
              <g>
                <path
                  fill="#FFF"
                  d="M30.377 9.67c.285.002.56-.035.825-.112.265-.077.5-.21.704-.4.204-.19.368-.435.491-.739.124-.303.186-.687.188-1.153l.002-.466-2.261.35c-.353.055-.649.185-.887.388-.238.204-.358.51-.36.92 0 .31.106.59.323.838.216.248.54.373.975.375zm-4.006-1.054c.002-.466.082-.878.24-1.238.157-.36.371-.673.644-.94.273-.267.589-.477.95-.631.36-.154.75-.265 1.17-.334l2.465-.37c.285-.042.482-.13.592-.263.109-.134.164-.292.164-.476.002-.367-.136-.685-.413-.955-.277-.27-.7-.405-1.27-.408-.598-.002-1.057.165-1.377.503-.32.337-.501.732-.544 1.184l-2.4-.54c.043-.41.166-.818.372-1.227.205-.408.484-.774.838-1.098.355-.323.79-.586 1.306-.788.517-.203 1.114-.303 1.793-.3.787.003 1.458.116 2.013.337.556.221 1.006.512 1.351.874.345.361.593.783.748 1.263.154.481.23.983.228 1.505l-.02 5.126c-.001.283.011.582.037.9.026.318.052.569.079.752l-2.484-.01c-.026-.142-.049-.335-.068-.583-.02-.247-.03-.47-.028-.667-.26.408-.631.767-1.114 1.075-.483.309-1.098.462-1.844.458-.53-.002-1.007-.092-1.434-.27-.427-.179-.789-.413-1.086-.704-.298-.29-.524-.624-.678-.998-.155-.375-.231-.767-.23-1.177zM11.72 7.474c-.143.367-.331.673-.563.919-.231.246-.504.432-.816.558-.313.125-.632.188-.958.186-.325-.001-.644-.066-.955-.195-.312-.128-.583-.316-.812-.564-.23-.248-.415-.556-.557-.924-.14-.367-.21-.798-.209-1.293.003-.494.076-.924.22-1.29.144-.367.33-.674.563-.92.231-.246.504-.432.816-.558.313-.125.632-.188.958-.186.325.001.644.066.956.195.311.128.582.316.812.564.23.248.415.556.556.924.14.368.21.799.208 1.293-.001.494-.074.925-.218 1.291m2.553-3.46c-.006-.014-.01-.03-.016-.046-.262-.678-.625-1.262-1.092-1.751-.466-.49-1.021-.873-1.664-1.151-.644-.278-1.34-.419-2.085-.422-.747-.003-1.443.131-2.088.404-.646.273-1.204.652-1.674 1.137S4.816 3.25 4.55 3.928c-.267.676-.402 1.417-.406 2.222-.003.805.127 1.543.389 2.215.262.672.626 1.256 1.092 1.752.466.496 1.021.883 1.665 1.161.643.278 1.338.42 2.084.422.746.003 1.443-.132 2.088-.404.646-.273 1.204-.655 1.674-1.148.47-.492.839-1.072 1.106-1.742.007-.017.011-.035.018-.052-.194-.679-.29-1.403-.288-2.163.003-.763.105-1.492.303-2.176M20.744 3.297c-.353-.001-.682.06-.988.187-.306.125-.575.312-.806.558-.232.246-.416.552-.553.918-.137.367-.207.783-.209 1.25-.002.465.064.882.199 1.25.134.367.32.679.556.934.236.255.507.447.812.575.305.129.633.193.987.195.339.002.641-.05.906-.155.265-.104.492-.241.684-.41.19-.169.343-.359.46-.57.116-.211.201-.416.256-.613l2.379.836c-.11.437-.292.864-.545 1.28-.252.415-.576.788-.97 1.117-.396.33-.858.597-1.388.8-.53.202-1.128.302-1.793.3-.732-.004-1.42-.144-2.064-.423-.644-.278-1.202-.665-1.675-1.161-.473-.496-.844-1.08-1.112-1.752-.27-.672-.402-1.41-.399-2.215.003-.805.138-1.546.406-2.223.267-.676.636-1.257 1.106-1.742.47-.485 1.021-.864 1.653-1.137.632-.272 1.314-.407 2.047-.404.679.003 1.285.108 1.82.315.536.207 1 .473 1.392.8.392.327.71.702.952 1.126.243.425.417.857.524 1.295l-2.425.837c-.12-.438-.353-.842-.698-1.21-.344-.37-.85-.555-1.514-.558"
                  transform="translate(-72 -18) translate(72 18) translate(0 4) translate(0 4)"
                />
                <path
                  fill="#FC0"
                  d="M0 20L39.549 20 39.549 17.183 0 17.183z"
                  transform="translate(-72 -18) translate(72 18) translate(0 4) translate(0 4)"
                />
              </g>
            </g>
            <g>
              <path
                fill="#FFF"
                d="M12.35 1.099c-.839-.408-1.828-.26-2.821.814-.365.377-1.627 2.313-2.349 4.368-.439 1.25-.706 2.525-.746 3.396.074.007.15.013.223.023.346.046.664.15.948.3.493-.666 1.107-1.675 1.786-2.682 1.24-1.837 2.673-3.27 2.966-3.653.881-1.15.836-2.156-.008-2.566"
                transform="translate(-72 -18) translate(72 18) translate(15)"
              />
              <path
                fill="#FF6E83"
                d="M11.525 2.014c-.584-.282-1.348-.111-2.075.764-.274.326-1.332 1.957-1.953 3.633-.5 1.351-.789 2.726-.709 3.312.164.03.32.07.47.125.426-.417 1.088-1.55 1.833-2.69.991-1.52 2.165-3.028 2.384-3.357.644-.97.635-1.504.05-1.787"
                transform="translate(-72 -18) translate(72 18) translate(15)"
              />
              <path
                fill="#FFF"
                d="M4.062 9.846c.363-.067.734-.123 1.106-.158.132-.862.095-2.227-.131-3.597-.357-2.15-1.265-4.278-1.56-4.713C2.686.147 1.738-.173.84.08c-.9.256-1.119 1.24-.45 2.525.223.43 1.386 2.092 2.29 4.119.534 1.197.993 2.384 1.382 3.121"
                transform="translate(-72 -18) translate(72 18) translate(15)"
              />
              <path
                fill="#FF6E83"
                d="M4.512 9.77l.225-.033c.28-.35.262-1.952-.035-3.573-.322-1.76-1.083-3.552-1.296-3.92-.565-.99-1.288-1.292-1.912-1.117-.625.176-.725.701-.26 1.769.16.362 1.055 2.053 1.77 3.723.627 1.468 1.146 2.904 1.508 3.15"
                transform="translate(-72 -18) translate(72 18) translate(15)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

LocalLogo.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

LocalLogo.defaultProps = {
  width: 50,
  height: 34,
};

export default LocalLogo;
